export enum PanelType {
  Notifications = "Notifications",
  Settings = "Settings",
  UserSettings = "My account",
  AppLauncher = "App launcher",
}
